import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const links = [{
    name: 'Celebrate',
    href: '/#celebrate'
  }, {
    name: 'Honor',
    href: '/#honor'
  }, {
    name: 'Support',
    href: '/#support'
  }, {
    name: 'Event',
    href: '/#event'
  }, {
    name: 'Flyer',
    href: '/#flyer'
  }, {
    name: 'Partner',
    href: '/#partner'
  }, {
    name: 'About',
    href: '/about'
  }];
  return <footer className="bg-white py-16 border-t border-[#ecdfd2]" data-id="element-52">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        {/* Top section with logos and navigation */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12" data-id="element-54">
          {/* Left: Logos and tagline */}
          <div className="lg:col-span-1" data-id="element-55">
            <div className="flex items-center gap-4 mb-6" data-id="element-56">
              <img src="https://cdn.magicpatterns.com/uploads/4tAPPhhSxFFzHh1MdQYkPw/Good_Father_Project.png" alt="Good Father Project" className="h-12 w-auto" data-id="element-57" />
              <img src="https://cdn.magicpatterns.com/uploads/jiXzHYbTVX6No9MUBUqJKf/Fatherhood_Initiative.png" alt="Fatherhood Matters" className="h-12 w-auto" data-id="element-58" />
            </div>
            <p className="text-[#5a3a28]/70 text-sm leading-relaxed max-w-sm" data-id="element-59">
              Strengthening families through reflection, presence, and community
              partnership. An initiative dedicated to the quiet, vital work of
              fatherhood.
            </p>
          </div>

          {/* Middle: Navigation */}
          <div data-id="element-60">
            <h3 className="text-xs font-semibold text-[#d4956a] uppercase tracking-wider mb-4" data-id="element-61">
              Navigation
            </h3>
            <nav className="flex flex-col space-y-3" data-id="element-62">
              {links.map(link => {
              const isInternal = link.href.startsWith('/') && !link.href.includes('#');
              if (isInternal) {
                return <Link key={link.name} to={link.href} className="text-[#5a3a28] hover:text-[#c06a2b] text-sm transition-colors" data-id="element-63">
                      {link.name}
                    </Link>;
              }
              return <a key={link.name} href={link.href} className="text-[#5a3a28] hover:text-[#c06a2b] text-sm transition-colors" data-id="element-64">
                    {link.name}
                  </a>;
            })}
            </nav>
          </div>

          {/* Right: Contact */}
          <div data-id="element-65">
            <h3 className="text-xs font-semibold text-[#d4956a] uppercase tracking-wider mb-4" data-id="element-66">
              Contact
            </h3>
            <a href="mailto:info@goodfatherproject.org" className="text-[#5a3a28] hover:text-[#c06a2b] text-sm transition-colors" data-id="element-67">
              info@goodfatherproject.org
            </a>
          </div>
        </div>

        {/* Bottom section */}
        <div className="pt-8 border-t border-[#ecdfd2] flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-68">
          <p className="text-[#d4956a] text-sm" data-id="element-69">
            © 2026 The Good Father Project
          </p>
          <div className="flex items-center gap-6 text-sm text-[#d4956a]" data-id="element-70">
            <a href="https://www.travishellstrom.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#c06a2b] transition-colors" data-id="element-71">
              Powered by Optimism
            </a>
          </div>
        </div>
      </div>
    </footer>;
}